exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/** RentAll - Begin **/\n.ReportUserModal-logInModalContainer-ci-I9 {\n  max-width: 468px;\n  width: 100%;\n  margin: 160px auto;\n}\n\n.ReportUserModal-logInModalBody-TgWlo {\n  padding: 25px;\n}\n\n@media screen and (max-width: 767px) {\n  .ReportUserModal-logInModalContainer-ci-I9 {\n    margin: 0px auto;\n    padding: 10px;\n  }\n}", ""]);

// exports
exports.locals = {
	"logInModalContainer": "ReportUserModal-logInModalContainer-ci-I9",
	"logInModalBody": "ReportUserModal-logInModalBody-TgWlo"
};